export default __webpack_public_path__ + "static/ca-7ed3b1ae6f1301af6d20106aa767b98e.jpg";